import { rem } from '@visiba/std';
import { Text } from '@visiba-cortex/react-ui-std';
import { motion } from 'framer-motion';
import { FONT_VARIANT } from '../../constants';
import styled from 'styled-components';
import { Icon } from '@components/icon.component';
import { theme } from '@services/theme.service/theme';
import { SyntheticEvent } from 'react';
import { AnalyticLink } from '@components/analytic_link/analytic_link.component';
import { useService } from '@visiba/instantiation';
import { AnalyticCategories, AnalyticService } from '@application/analytic/analytic.service';

interface Props {
	alertiveTitle?: boolean;
	description: string;
	to: string;
	analyticAction: string;
	ariaLabel?: string;
	children: JSX.Element;
}

const elements = {
	container: styled(motion.div)`
		display: flex;
		flex-direction: column;
		position: absolute;
		top: ${rem(100)};
		right: 20px;
		pointer-events: all;
		width: 100vw;
		max-width: ${rem(355)};
		transform-origin: center right;
	`,
	title: styled(Text)`
		margin-bottom: ${rem(8)};
		padding-left: ${rem(8)};
		display: flex;
		align-items: center;
	`,
	alertiveIcon: styled.span`
		display: flex;
		margin-right: ${rem(4)};
		color: ${theme.accentColor};
	`,
};

export function AttentionCardCaseCardWrapper({
	children,
	alertiveTitle,
	analyticAction,
	description,
	to,
	ariaLabel,
}: Props): JSX.Element {
	return (
		<elements.container
			transition={{
				type: 'spring',
				duration: 0.35,
			}}
			initial={{ opacity: 0, x: 20, scale: 0.9 }}
			animate={{ opacity: 1, x: 0, scale: 1 }}
		>
			<elements.title font={FONT_VARIANT.BODY}>
				{alertiveTitle ? (
					<elements.alertiveIcon>
						<Icon type='error' />
					</elements.alertiveIcon>
				) : null}
				{description}
			</elements.title>

			<UglyMessLink__TEMP__ to={to} analyticAction={analyticAction} ariaLabel={ariaLabel}>
				{children}
			</UglyMessLink__TEMP__>
		</elements.container>
	);
}

interface UglyMessProps {
	to: string;
	analyticAction: string;
	ariaLabel?: string;
	children: JSX.Element;
}

function UglyMessLink__TEMP__({ to, ariaLabel, analyticAction, children }: UglyMessProps): JSX.Element {
	const analyticService = useService(AnalyticService);

	if (window.__TEMP__overrideNavigation) {
		function handleIntercept(event: SyntheticEvent<HTMLAnchorElement>): void {
			event.preventDefault();

			if (window.__TEMP__overrideNavigation && to) {
				window.__TEMP__overrideNavigation(to);

				analyticService.trackEvent(AnalyticCategories.AttentionCards, analyticAction);
			}
		}

		return (
			<a href={to} aria-label={ariaLabel} onClick={handleIntercept}>
				{children}
			</a>
		);
	}

	return (
		<AnalyticLink to={to} action={analyticAction} aria-label={ariaLabel}>
			{children}
		</AnalyticLink>
	);
}
